exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-autosuggest__container{position:relative}.react-autosuggest__input{width:240px;height:30px;padding:10px 20px;font-family:Open Sans,sans-serif;font-weight:300;font-size:16px;border:1px solid #aaa;border-radius:4px}.react-autosuggest__input:focus{outline:none}.react-autosuggest__container--open .react-autosuggest__input{border-bottom-left-radius:0;border-bottom-right-radius:0}.react-autosuggest__suggestions-container{position:absolute;width:280px;margin:0;padding:0;list-style-type:none;border:1px solid #aaa;background-color:#fff;font-family:Open Sans,sans-serif;font-weight:300;font-size:16px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;z-index:2}.react-autosuggest__suggestion{cursor:pointer;padding:10px 20px}.react-autosuggest__suggestion--focused{background-color:#ddd}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/main/stylesheets/react-autosuggest.css
 ** module id = 753
 ** module chunks = 0
 **/